import React from 'react';
import classnames from 'classnames';

import styles from './heading.module.scss';

export type HeadingProps = {
  tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'div' | 'span' | 'label' | 'figcaption';
  variant:
    | 'unstyled'
    | 'headline-functional-100'
    | 'headline-emotional-100'
    | 'headline-functional-200'
    | 'headline-emotional-200'
    | 'headline-functional-300'
    | 'headline-emotional-300'
    | 'headline-functional-400'
    | 'headline-emotional-400'
    | 'display-functional-100'
    | 'display-emotional-100'
    | 'display-functional-200'
    | 'display-functional-200-fixed'
    | 'display-emotional-200'
    | 'display-functional-300'
    | 'display-emotional-300'
    | 'subheadline-100'
    | 'subheadline-200';
} & Pick<React.HTMLAttributes<HTMLHeadingElement>, 'children' | 'className' | 'id'>;
type HeadingRefTypes = HTMLHeadingElement & HTMLDivElement & HTMLSpanElement & HTMLLabelElement;

const baseClass = 'heading';

export const Heading = React.forwardRef<HeadingRefTypes, HeadingProps>(
  ({ className, id, tag: Component = 'h1', children, variant }, ref) => {
    const classes = classnames(styles.heading, styles[`${baseClass}--${variant}`], className);

    return (
      <Component className={classes} id={id} data-testid="heading-component" ref={ref}>
        {children}
      </Component>
    );
  }
);

Heading.displayName = 'Heading';
